import axios from 'axios';
import qs from 'qs';

class GetFileRequest {
  idsecureAPI = process.env.REACT_APP_IDSECURE_API_URL_REPORTS



  async PDF(api: string, filtros: any, headers: string[], columns?: string[]) {
    return axios.get(`${this.idsecureAPI}${api}`, {
      responseType: filtros.pageSize >= 10000 ? 'json' : 'blob',
      //  responseType: 'blob',
      params: { ...filtros, pageNumber: 1, headers: headers, columns: columns, exportType: "PDF" },
      paramsSerializer: (prms) => {
        return qs.stringify(prms, { arrayFormat: 'repeat' });
      }
    });
  }

  listPDFs(params: any) {
    return axios.get(`${this.idsecureAPI}/reportStatus`, { params });
  }
}


export const getFileRequest = new GetFileRequest()